/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import { isPresent } from '@ember/utils';
import Component from '@glimmer/component';

export interface IStatusFilterComponentArgs {
  possibleValues: IStatusOption[];
  renderInPlace?: boolean;
  horizontalPosition?: 'right' | 'left' | 'auto';
  matchTriggerWidth?: boolean;
  hideCount?: boolean;
  allowClear?: boolean;
  label?: string;
}


export default class FiltersStatusFilterComponent extends Component<FilterComponentSignature<IStatusFilterComponentArgs>> {
  get selected() {
    const { values = [], multiple, componentArgs } = this.args;

    if (multiple) {
      return componentArgs.possibleValues?.filter((o) => o && values.includes(o.key));
    } else {
      return values.length > 0 ? componentArgs.possibleValues?.find((o) => o.key === values[0]) : undefined;
    }
  }

  private getValues(options: (IStatusOption | undefined)[]) {
    return options.reduce((acc: string[], o) => {
      const v = o?.['key'];
      if (isPresent(v)) {
        acc.push(v as string);
      }
      return acc;
    }, []);
  }

  @action
  valuesDidChange(values: IStatusOption[]) {
    this.args.onChange?.(this.getValues(values));
  }

  @action
  singleValueDidChange(value?: IStatusOption) {
    this.args.onChange?.(value ? [value.key] : []);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Filters::StatusFilter': typeof FiltersStatusFilterComponent;
    'filters/status-filter': typeof FiltersStatusFilterComponent;
  }
}
